module.exports = __webpack_public_path__ + "img/sld_mfm_t1_b1_black.a02e8f61.svg";